module.exports = __webpack_public_path__ + "img/shymkent3.2efa6dc8.jpg";